import React, { useMemo, type FC } from 'react';

import { ImagesInfoBlock } from '@/shared/components/ImagesInfoBlock/ImagesInfoBlock';
import { InfoBlockPrimaryPurchaseButton } from '@/scenarios/home/components/multi-offer-info-blocks/InfoBlockPrimaryPurchaseButton/InfoBlockPrimaryPurchaseButton';

import { usePaywallContext } from '../../../hooks/usePaywallContext';
import { useI18n } from '../../../hooks/useI18n';

export const BenefitsInfoBlock: FC = () => {
    const { offer, paymentPlace } = usePaywallContext();
    const i18n = useI18n();

    const items = useMemo(() => {
        const benefitItemFamily = {
            title: i18n('home__benefits__family_card__title'),
            subtitle: i18n('home__allplay__benefits__family_card__subtitle'),
            backgroundImage:
                'https://avatars.mds.yandex.net/get-ott/236744/2a0000019a33f7d382eb11379a7832290965/orig',
        };

        const benefitItemWatch = {
            title: i18n('home__benefits__watch_card__title'),
            subtitle: i18n('home__allplay__benefits__watch_card__subtitle'),
            backgroundImage:
                'https://avatars.mds.yandex.net/get-ott/1648503/2a0000019a33f87892d7ce716c2349e50455/orig',
        };

        const benefitItemDownload = {
            title: i18n('home__benefits__download_card__title'),
            subtitle: i18n('home__allplay__benefits__download_card__subtitle'),
            backgroundImage:
                'https://avatars.mds.yandex.net/get-ott/2419418/2a0000019a33f8b47158d0dff49c3b6b28f7/orig',
        };

        return [benefitItemFamily, benefitItemWatch, benefitItemDownload];
    }, [i18n]);

    return (
        <ImagesInfoBlock
            subtitle={i18n('home__benefits__subtitle')}
            primaryButton={
                <InfoBlockPrimaryPurchaseButton
                    offer={offer}
                    paymentPlace={paymentPlace}
                    text=""
                    contentType="BenefitsInfoBlock"
                    size={60}
                    alignment="centered"
                />
            }
            items={items}
        />
    );
};
